import { Pipe, PipeTransform } from '@angular/core';
import * as dayjs from 'dayjs';
import { CtaType, ProductType } from './../enums/content.enum';

@Pipe({
  name: 'componentCtaLink'
})
export class ComponentCtaLinkPipe implements PipeTransform {


  constructor() { }

  transform(content: any, ctaType: CtaType, pages: any): string {
    switch (ctaType) {
      case CtaType.DETAIL:
        return this.getDetailLink(content);
      case CtaType.MULTIPRODUCT:
        return this.getCustomPageLink(content, pages);
      case CtaType.EXTERNAL_LINK:
        return this.getExternalPageLink(content);
      case CtaType.NEWS:
        return this.getCustomPageLink(content, pages);
      case CtaType.CUSTOMPRODUCT:
        return this.getCustomPageLink(content, pages);
    }
  }

  private getExternalPageLink(content: any): string {
    return '//' + this.removeProtocol(content.ctaTarget);
  }

  private removeProtocol(url: string): string {
    return url?.replace(/^(https?:\/\/)/, '');
  }

  private getDetailLink(content: any): string {
    // TODO to be removed when the tour implementation will also work for alpitour
    if(content.products[0]?.pluginSource === 51) {
      return this.holidayDetailLink(content.products[0]);
    }

    switch (content.products[0]?.productType?.id) {
      case ProductType.Holiday:
        return this.holidayDetailLink(content.products[0]);
      case ProductType.Tour:
        return this.tourDetailLink(content);
      case ProductType.Cruise:
        return this.cruiseDetailLink(content.products[0]);
    }
  }

  private holidayDetailLink(product: any): string {
    const ages = product.ages?.join(',') || `35,35`;
    const nights = product.nights || 0;
    const accomodationName = product?.accommodation?.name.split(' ')?.join('-')?.replace(/\//g, '-') || 't';
    const realTourOperatorId = product.realTourOperator ? product.realTourOperator.id : null;
    const tourOperatorId = product.tourOperator ? product.tourOperator.id : null;
    let topId = tourOperatorId;
    if (realTourOperatorId && product.pluginSource === 52 && realTourOperatorId !== tourOperatorId) {
      topId = realTourOperatorId;
    }
    const link = `vacanze/dettaglio/${product?.accommodation?.id}/${topId}/${product?.source}/${product?.pluginSource}/struttura/${accomodationName}/dal/${dayjs(product?.departureDateFrom).format('DD-MM-YYYY')}/al/${dayjs(product?.departureDateTo).add(1, 'week').format('DD-MM-YYYY')}/durata/${nights}/eta/${ages}`;
    //console.log('GENERATED LINK: ', link, 'PRODUCT: ', product);
    return link;
  }

  private tourDetailLink(content: any): string {
    const product = content.products[0];
    const ages = product.ages?.join(',') || `35,35`;
    const nights = product.nights || 0;
    const accomodationName = content?.title?.split(' ')?.join('-')?.replace(/\//g, '-') || 't';
    const realTourOperatorId = product.realTourOperator ? product.realTourOperator.id : null;
    const tourOperatorId = product.tourOperator ? product.tourOperator.id : null;
    let topId = tourOperatorId;
    if (realTourOperatorId && product.pluginSource === 52 && realTourOperatorId !== tourOperatorId) {
      topId = realTourOperatorId;
    }
    const link = `tour/dettaglio/${product?.tourCustom}/${topId}/${product?.source}/${product?.pluginSource}/struttura/${accomodationName}/dal/${dayjs(product?.departureDateFrom).format('DD-MM-YYYY')}/al/${dayjs(product?.departureDateTo).add(1, 'week').format('DD-MM-YYYY')}/durata/${nights}/eta/${ages}`;
    return link;
  }

  private cruiseDetailLink(product: any): string {
    const link = `crociere/dettaglio/${product?.source}/0/pacchetto/${product?.itinerary.description.split(', ')?.join('-')}/volo/NO/dal/${dayjs(product?.departureDateFrom).format('DD-MM-YYYY')}/al/${dayjs(product?.departureDateTo).add(1, 'week').format('DD-MM-YYYY')}`;
    //console.log('GENERATED LINK: ', link, 'PRODUCT: ', product);
    return link;
  }

  private getCustomPageLink(content: any, pages: any): string {
    const page = pages.find(x => x.id == content.ctaTarget);
    if (page) {
      const pagePath = page.path;
      return content.ctaType.pageTypesRef[0].basePath + pagePath;
    } else {
      return null;
    }
  }

}
